import { drama } from '../../../constants/actionTypes';

const initState = 0;

export default (state = initState, { type, count }) => {
  switch (type) {
    case drama.FETCH_DRAMA_COMMENTS_SUCCESS:
      return count;

    case drama.POST_DRAMA_COMMENT_SUCCESS:
      return state + 1;

    case drama.DELETE_DRAMA_COMMENT_SUCCESS: {
      return state - 1;
    }

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
